<script>
import { Line,Bar } from "vue-chartjs";
import {
  getStyle,
  hexToRgba
} from "@coreui/coreui-pro/dist/js/coreui-utilities";
import { CustomTooltips } from "@coreui/coreui-plugin-chartjs-custom-tooltips";
import { random } from "@/shared/utils";

export default {
  extends: Line,
  props: ["height", "range"],
  watch: {
    range: function(val) {
      this.onData()
    }
  },
  mounted(){
    this.$nextTick(() => {
      this.onData()
     })
  },
  methods:{
    onData() {
      const brandSuccess = getStyle("--success") || "#4dbd74";
      const brandInfo = getStyle("--info") || "#20a8d8";
      const brandDanger = getStyle("--danger") || "#f86c6b";

      const _avgrpm = [];
      const _avgwatt = [];
      const _avghr = [];
      const _labels = [];
     
      this.$store.dispatch("fetchSpinningData", { activity: 'all', range: this.range, limit: 100, orderBy:[{directionStr:'asc'}]}).then(
        sessions => {
          sessions.forEach(element => {
            let data = element.data;
          
            const watt = data.map(a => a.pow)
            var avgwatt = parseFloat(watt.reduce(function(a, b) { return a + b; }, 0) / watt.length).toFixed(2)

            const hr = data.map(a => a.hr)
            var avghr = parseFloat(hr.reduce(function(a, b) { return a + b; }, 0) / hr.length).toFixed(2)

            _avgrpm.push(element.avgrpm);
            _avgwatt.push(avgwatt);
            _avghr.push(avghr);

            const _date = this.$moment.utc(element.closedAt * 1000).format("DD-MM-YYYY");
            _labels.push(_date);
            this.renderChart(
              {
                labels: _labels,
                datasets: [
                  {
                    type: 'line',
                    label: "AVG RPM",
                    backgroundColor: hexToRgba(brandInfo, 10),
                    borderColor: brandInfo,
                    pointHoverBackgroundColor: "#fff",
                    borderWidth: 2,
                    data: _avgrpm,
                 
                  },
                  {
                    type: 'line',
                    label: "AVG WATTS",
                    backgroundColor: hexToRgba(brandSuccess, 10),
                    borderColor: brandSuccess,
                    pointHoverBackgroundColor: "#fff",
                    borderWidth: 2,
                    data: _avgwatt
                  },
                  {
                    type: 'line',
                    label: "AVG HR",
                    backgroundColor: hexToRgba(brandDanger, 10),
                    borderColor: brandDanger,
                    pointHoverBackgroundColor: "#fff",
                    borderWidth: 2,
                    data: _avghr
                  }
                ]
              },
              {
                tooltips: {
                  enabled: false,
                  custom: CustomTooltips,
                  intersect: true,
                  mode: "index",
                  position: "nearest",
                  callbacks: {
                    labelColor: function(tooltipItem, chart) {
                      return {
                        backgroundColor:
                          chart.data.datasets[tooltipItem.datasetIndex].borderColor
                      };
                    }
                  }
                },
                maintainAspectRatio: false,
                responsive: true,
                legend: {
                  display: true,
                    labels: {
                      fontColor: '#ffffff'
                    }
                },
                scales: {
                  xAxes: [
                    {
                      gridLines: {
                        drawOnChartArea: true
                      },
                      ticks: {
                        maxTicksLimit: 5,
                        fontColor: 'white'
               
                      },
                    }
                  ],
                  yAxes: [
                    {
                      ticks: {
                        beginAtZero: true,
                        maxTicksLimit: 5,
                        fontColor: 'white'
               
                      },
                      gridLines: {
                        display: true
                      }
                    }
                  ]
                },
                elements: {
                  // point: {
                  //   radius: 0,
                  //   hitRadius: 10,
                  //   hoverRadius: 4,
                  //   hoverBorderWidth: 3
                  // }
                }
              }
            );
          });
        },
        error => {
          console.error("No user data", error);
        }
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/GlobalData.vue